import { ComponentProps } from "react";

type IconCheckProps = ComponentProps<"svg">;
export const IconCheck = (props: IconCheckProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="83"
      height="82"
      viewBox="0 0 83 82"
      fill="none"
      {...props}
    >
      <g clip-path="url(#clip0_443_31927)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M41.476 82C18.8984 82 0.5 63.6016 0.5 40.976C0.5 18.3984 18.8984 0 41.476 0C64.1016 0 82.5 18.3984 82.5 40.976C82.5 63.6016 64.1016 82 41.476 82Z"
          fill="#66AE32"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M41.4759 77.1482C21.5404 77.1482 5.30371 60.9595 5.30371 40.9759C5.30371 21.0404 21.5404 4.80371 41.4759 4.80371C61.4595 4.80371 77.6482 21.0404 77.6482 40.9759C77.6482 60.9595 61.4595 77.1482 41.4759 77.1482Z"
          fill="#7DD63E"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M35.7115 56.9241C35.4233 56.9241 35.1351 56.828 34.9429 56.6358L21.6366 43.3294C21.4444 43.0893 21.3003 42.8491 21.3003 42.5608C21.3003 42.2726 21.4444 41.9844 21.6366 41.7922L26.4883 36.9405C26.9207 36.5081 27.5932 36.5081 28.0255 36.9405L35.7115 44.5784L54.9265 25.3634C55.3589 24.9791 56.0794 24.9791 56.4637 25.3634L61.3636 30.2152C61.7479 30.6475 61.7479 31.3201 61.3636 31.7524L36.4801 56.6358C36.288 56.828 35.9998 56.9241 35.7115 56.9241Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_443_31927">
          <rect
            width="82"
            height="82"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
